import {
  createBankHoliday as CreateBankHolidayRequest,
  deleteBankHoliday as deleteBankHolidayRequest,
  getBankHoliday as getBankHolidayRequest,
  listBankHolidays as listBankHolidaysRequest,
  updateBankHoliday as updateBankHolidayRequest
} from '@cbgms/api/modules/bank-holidays/requests'
import { IBankHoliday, IBankHolidayResponse, ICreateBankHoliday, IListBankHolidaysResponse, IResponse } from '@cbgms/api'
import * as types from './types'
import { AsyncAction } from '@cbgms/base/redux/async-action'
import { IPaginatedRequest } from '@cbgms/api/request'

export const listBankHolidays = (params: IPaginatedRequest) =>
  AsyncAction<IListBankHolidaysResponse>({
    type: [types.GET_BANK_HOLIDAYS, types.GET_BANK_HOLIDAYS_SUCCESS, types.GET_BANK_HOLIDAYS_FAILED],
    payload: {
      api: 'support',
      request: listBankHolidaysRequest(params)
    }
  })

export const getBankHoliday = (bankHolidayUUID: string) =>
  AsyncAction<IBankHolidayResponse>({
    type: [types.GET_BANK_HOLIDAY, types.GET_BANK_HOLIDAY_SUCCESS, types.GET_BANK_HOLIDAY_FAILED],
    payload: {
      api: 'support',
      request: getBankHolidayRequest(bankHolidayUUID)
    }
  })

export const updateBankHoliday = (bankHolidayUUID: string, data: Partial<IBankHoliday>) =>
  AsyncAction<IResponse<{ UUID: string }>>({
    type: [types.UPDATE_BANK_HOLIDAY, types.UPDATE_BANK_HOLIDAY_SUCCESS, types.UPDATE_BANK_HOLIDAY_FAILED],
    payload: {
      api: 'support',
      request: updateBankHolidayRequest(bankHolidayUUID, data)
    }
  })

export const deleteBankHoliday = (bankHolidayUUID: string) =>
  AsyncAction<IResponse<{ UUID: string }>>({
    type: [types.DELETE_BANK_HOLIDAY, types.DELETE_BANK_HOLIDAY_SUCCESS, types.DELETE_BANK_HOLIDAY_FAILED],
    payload: {
      api: 'support',
      request: deleteBankHolidayRequest(bankHolidayUUID)
    }
  })

export const createBankHoliday = (data: ICreateBankHoliday) =>
  AsyncAction<IResponse<{ UUID: string }>>({
    type: [types.CREATE_BANK_HOLIDAY, types.CREATE_BANK_HOLIDAY_SUCCESS, types.CREATE_BANK_HOLIDAY_FAILED],
    payload: {
      api: 'support',
      request: CreateBankHolidayRequest(data)
    }
  })
